import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import CancelOrder from '../components/CancelOrder'
import {
  cancelGivenOrder,
  clearCancelGivenOrder,
  updatePaymentsPaid,
  updateCancelFiscalCode,
} from '../actions'
import { orderSelector } from '@/checkout-instore-legacy/order/selectors'
import { deviceSelector } from '@/checkout-instore-legacy/native/selectors'

const mapStateToProps = (state) => ({
  order: orderSelector(state),
  device: deviceSelector(state),
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      cancelGivenOrder,
      clearCancelGivenOrder,
      updatePaymentsPaid,
      updateCancelFiscalCode,
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(CancelOrder)
